import GeneralDialog from "../../core/GeneralDialog";

const InvoiceSaveAndCommitDialog = (props: InvoiceSaveAndCommitDialogProps) => {
  return props.open ? (
    <GeneralDialog
      open={props.open}
      title="未保存する内容があります"
      cancelText="編集に戻る"
      saveText="保存して請求確定"
      onCancel={() => props.onClose()}
      onSave={() => props.onOk()}
      onClose={() => props.onClose()}
    >
      <div>未保存の内容があります。</div>
      <div>編集した内容を保存して請求を確定しますか？</div>
    </GeneralDialog>
  ) : (
    <></>
  );
};

export default InvoiceSaveAndCommitDialog;

export type InvoiceSaveAndCommitDialogProps = {
  open: boolean;
  onClose: () => void;
  onOk: () => void;
};
